import React from "react";
import AllUniversity from "../../Components/University/AllUniversity";
import Certificate from "../../Components/ExamPreparationCards/Certificate";
import AllUniversityBanner from "../../Components/University/AllUniversityBanner";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import Page from "../Metadata/Page";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import WhatsAppCMP from "../../Components/WhatsApp";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
const UniversityList = () => {
  const subCategoryId = "679480e4e20697cecf77d90c";
  const categoryId = "677e07a9159c38853391c934";
  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Universities" },
  ];

  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>

      <AllUniversityBanner />
      <SiteReviews />
      <WhatsAppCMP />
      <AllUniversity />
      <Certificate />
      <ScrollTop />
    </>
  );
};

export default UniversityList;
